export default "__VITE_ASSET__B15tBVw4__"